import styles from './shareInfo.module.scss';
import { Row, Col } from 'antd';
import gift from '@/assets/images/personal/gift.png';
import hot from '@/assets/images/personal/hot.png';
import contribution from '@/assets/images/personal/contribution.png';

import { userOverview, awardOverview } from "@/apis/statistics";
import { useEffect, useState } from 'react';
import { dealFileSize } from "@/utils/dealFileSize";
import { EyeOutlined, HeartOutlined, VerticalAlignBottomOutlined } from '@ant-design/icons';
import intl from 'react-intl-universal';
import classnames from 'classnames';

const ShareInfo = () => {
	const [data, setData] = useState({});
	const [obj, setObj] = useState({});
	useEffect(() => {
		userOverview().then(res => {
			setData(res.data)
		}).catch(err => { })

		awardOverview().then(res => {
			setObj(res.data)
		}).catch(err => { })
	}, [])

	return <div className={styles.shareInfoBox}>
		<Row gutter={40} align="stretch">
			<Col span={12}>
				<div className={styles.colBox}>
					<img src={contribution} />
					<h3>{intl.get('Resource Contribution Volume')}</h3>
					<div className={styles.weightBox}>
						<i>{data.SumOpenResourceCount || 0}{intl.get('items')}</i>
						<i>{dealFileSize(data.SumFileSizeB) || 0 + 'kb'}</i>
					</div>
				</div>
			</Col>
			<Col span={12}>
				<div className={styles.colBox}>
					<img src={hot} />
					<h3>{intl.get('Popularity')}</h3>
					<div className={styles.rightBox}>
						<EyeOutlined />
						<i>{intl.get("Share.Views")}</i>
						<i>{data.SumViewTimes || 0}</i>
					</div>
					<div className={styles.rightBox}>
						<HeartOutlined />
						<i>{intl.get("Share.Stars")}</i>
						<i>{data.SumCollectTimes || 0}</i>
					</div>
					<div className={styles.rightBox}>
						<VerticalAlignBottomOutlined />
						<i>{intl.get("Share.Downloads")}</i>
						<i>{data.SumDownloadTimes || 0}</i>
					</div>
				</div>
			</Col>

			<Col span={24}>
				<div className={classnames(styles.colBox, styles.bottomBox)}>
					<img src={gift} />
					<h3>{intl.get("Wuhan-1 Satellite Sample Contribution Rewards")}</h3>
					<div className={classnames('flex_box', 'flex_around')}>
						<div>
							<p>{intl.get("Number of Convertible Samples")}</p>
							<div className={styles.rightBox}>
								<span></span>
								<i>{intl.get("Scene Classification")}：</i>
								<i>{obj.sceneClassificationAvailableNum || 0}</i>
							</div>
							<div className={styles.rightBox}>
								<span></span>
								<i>{intl.get("Object Detection")}：</i>
								<i>{obj.objectDetectionAvailableNum || 0}</i>
							</div>
							<div className={styles.rightBox}>
								<span></span>
								<i>{intl.get("Semantic Segmentation")}：</i>
								<i>{obj.semanticSegmentationAvailableNum || 0}</i>
							</div>
							<div className={styles.rightBox}>
								<span></span>
								<i>{intl.get("Change Detection")}：</i>
								<i>{obj.changeDetectionAvailableNum || 0}</i>
							</div>
						</div>
						<div>
							<p>{intl.get("Contribution Points")}</p>
							<h2>{obj.userSumPoints || 0}</h2>
						</div>
					</div>
				</div>
			</Col>
		</Row>
	</div>
}
export default ShareInfo;